import React from 'react';
import ReactDOM from 'react-dom';

export const AlertDialog = ({ isOpen, title, message, onClose }) => {
  if (!isOpen) return null;

  const handleButtonClick = () => {
    onClose();
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return ReactDOM.createPortal(
    <div 
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-50"
      onClick={handleOverlayClick}
    >
      <div className="bg-white rounded-lg shadow-lg max-w-sm w-full p-6 mx-4">
        <h2 className="text-lg font-bold mb-4">{title}</h2>
        <p className="text-sm text-gray-700 mb-6">{message}</p>
        <div className="flex justify-end">
          <button
            onClick={handleButtonClick}
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 cursor-pointer"
            type="button"
            style={{ pointerEvents: 'auto' }}
          >
            OK
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

